import { render, staticRenderFns } from "./modalAgregarPaquete.vue?vue&type=template&id=9888ad98&scoped=true&"
import script from "./modalAgregarPaquete.vue?vue&type=script&lang=js&"
export * from "./modalAgregarPaquete.vue?vue&type=script&lang=js&"
import style0 from "./modalAgregarPaquete.vue?vue&type=style&index=0&id=9888ad98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9888ad98",
  null
  
)

export default component.exports